import React from "react";
import PropTypes from "prop-types";
import moment from "moment";
import SetFavorite from "components/RestaurantDetails/SetFavorite.js";

export default function RestaurantHead(props) {
  const restaurant = props.restaurant;
  const getCertification = () => {
    const certification = props.restaurant.certificationRequest;
    if (
      certification &&
      (certification.status === "fulfilled" ||
        certification.status === "completed")
    ) {
      const date = new Date(certification.date);
      let dateDisplayed = "";
      const dateDay = moment(date)
        .format("DD")
        .toString();
      const dateMonth = moment(date)
        .format("MM")
        .toString()
        .toLowerCase();
      const dateYear = moment(date)
        .format("YYYY")
        .toString();
      dateDisplayed = `${dateDay} ${dateMonth} ${dateYear}`;
      return (
        <div className="RestaurantInfo-certification">
          {/* <i className="icon icon-cockade-24" style={{ fontSize: '25px' }} /> */}
          <span style={{ marginRight: "2px" }}>Struttura certificata</span>
          <span style={{ textAlign: "left" }}>{dateDisplayed}</span>
        </div>
      );
    }
    return null;
  };

  const getAttributes = type => {
    const restaurant = props.restaurant;
    if (!restaurant.service) {
      restaurant.service = [];
    }
    let attributes = [];
    // const displayedAttributes = [];
    if (type === "categories") {
      const categories = [].concat(restaurant.categories);
      categories.shift();
      attributes = categories;
    } else if (type === "idealFor") {
      attributes = restaurant.idealForEventTypes;
    } else if (type === "service") {
      attributes = restaurant.service
        .filter(el => el._id.type === "service")
        .map(element => element._id);
    } else if (type === "menu") {
      attributes = restaurant.service
        .filter(el => el._id.type === "menu")
        .map(element => element._id);
    } else if (type === "location") {
      attributes = restaurant.service
        .filter(el => el._id.type === "location")
        .map(element => element._id);
    } else if (type === "hotel") {
      attributes = restaurant.service
        .filter(el => el._id.type === "hotel")
        .map(element => element._id);
    } else if (type === "meal") {
      attributes = restaurant.service
        .filter(el => el._id.type === "meal")
        .map(element => element._id);
    } else {
      attributes = restaurant.typesOfFood;
    }
    const displayedAttributes = attributes.map((element, index) => (
      <span key={`attribute-${type}-${index.toString()}`}>
        {element && element[`label_it`] ? element[`label_it`] : ""}
        {index < attributes.length - 1 ? ", " : null}
      </span>
    ));
    return displayedAttributes;
  };

  const getParkingDetails = () => {
    const restaurant = props.restaurant;
    const parking = restaurant.service.filter(el => el._id.type === "parking");
    return parking.map(el => (
      <div
        className="RestaurantInfo-label-description"
        key={`restaurant-details-parking-details-nknknknknknknkn-${el._id._id.toString()}`}
      >
        {el._id[`label_it`]}
      </div>
    ));
  };

  const getSocial = () => {
    const displayedSocial = [];
    const links = props.restaurant.links;
    if (
      (links.facebookLinks &&
        links.facebookLinks.length > 0 &&
        links.facebookLinks[0]) ||
      (props.restaurant.facebook && props.restaurant.facebook.link)
    ) {
      displayedSocial.push(getLink("facebook", "fab fa-facebook-f"));
    }
    if (
      links.googlePlusLinks &&
      links.googlePlusLinks.length > 0 &&
      links.googlePlusLinks[0]
    ) {
      displayedSocial.push(getLink("googlePlus", "fab fa-google-plus-g"));
    }
    if (
      links.instagramLinks &&
      links.instagramLinks.length > 0 &&
      links.instagramLinks[0]
    ) {
      displayedSocial.push(getLink("instagram", "fab fa-instagram"));
    }
    if (
      links.linkedinLinks &&
      links.linkedinLinks.length > 0 &&
      links.linkedinLinks[0]
    ) {
      displayedSocial.push(getLink("linkedin", "fab fa-linkedin-in"));
    }
    if (
      links.pinterestLinks &&
      links.pinterestLinks.length > 0 &&
      links.pinterestLinks[0]
    ) {
      displayedSocial.push(getLink("pinterest", "fab fa-pinterest-p"));
    }
    if (
      links.twitterLinks &&
      links.twitterLinks.length > 0 &&
      links.twitterLinks[0]
    ) {
      displayedSocial.push(getLink("twitter", "fab fa-twitter"));
    }
    return displayedSocial;
  };

  const getLink = (type, icon) => {
    const links = props.restaurant.links;
    if (type === "googlePlus") {
      return (
        <div
          key={`${type}WebLinkPage`}
          style={{ float: "left", marginRight: "13px" }}
        >
          <button
            style={{ outline: "none", marginRight: "10px" }}
            className="DetailsRestaurantContacts_social_links"
            onClick={e => {
              let url = "";
              if (!links[`${type}Links`][0].includes("http")) {
                url = "http://";
              }
              if (!links[`${type}Links`][0].includes("plus.google.com")) {
                url += "plus.google.com";
              }
              if (!links[`${type}Links`][0].includes("/")) {
                url += "/";
              }
              url += `${links[`${type}Links`][0]}`;
              // console.log('url', url);
              window.open(url, "_blank");
              e.preventDefault();
            }}
          >
            <i className={icon} />
          </button>
        </div>
      );
    }
    if (
      type === "facebook" &&
      props.restaurant.facebook &&
      props.restaurant.facebook.link
    ) {
      return (
        <div
          key={`${type}WebLinkPage`}
          style={{ float: "left", marginRight: "13px" }}
        >
          <button
            style={{ outline: "none", marginRight: "10px" }}
            className="DetailsRestaurantContacts_social_links"
            onClick={e => {
              const url = props.restaurant.facebook.link;
              // console.log('url', url);
              window.open(url, "_blank");
              e.preventDefault();
            }}
          >
            <i className={icon} />
          </button>
        </div>
      );
    }
    return (
      <div
        key={`${type}WebLinkPage`}
        style={{ float: "left", marginRight: "13px" }}
      >
        <button
          style={{ outline: "none", marginRight: "10px" }}
          className="DetailsRestaurantContacts_social_links"
          onClick={e => {
            let url = "";
            if (!links[`${type}Links`][0].includes("http")) {
              url = "http://";
            }
            if (!links[`${type}Links`][0].includes(type)) {
              url += `${type}.com`;
            }
            if (!links[`${type}Links`][0].includes("/")) {
              url += "/";
            }
            url += `${links[`${type}Links`][0]}`;
            // console.log('url', url);
            window.open(url, "_blank");
            e.preventDefault();
          }}
        >
          <i className={icon} />
        </button>
      </div>
    );
  };

  const getContacts = () => {
    let emails = [];
    let phones = [];
    let mainPhone = [];
    const restaurant = props.restaurant;
    if (restaurant.emailPublic.length > 1) {
      emails = restaurant.emailPublic.map((el, index) => {
        if (el.name && el.email && index > 0) {
          return (
            <div
              key={`other-email-${index.toString()}`}
              style={{ fontSize: "15px", float: "left", width: "100%" }}
            >
              <span className="RestaurantInfo-label-description">
                {el.name || "email"}{" "}
              </span>
              <meta itemProp="email" content={el.email} />
              <a
                style={{
                  height: "31px",
                  borderBottom: "none",
                  cursor: "pointer"
                }}
                className="foodiestrip_back_to_results"
                href={`mailto:${el.email}`}
              >
                {el.email}
              </a>
            </div>
          );
        }
        return null;
      });
    }
    let telephonePrimary = "";
    if (
      restaurant.mainPhone &&
      restaurant.mainPhone.prefix &&
      restaurant.mainPhone.number
    ) {
      telephonePrimary = `${restaurant.mainPhone.prefix} ${restaurant.mainPhone.number}`;
      mainPhone = (
        <div key={`restaurant-main-phone-${restaurant.name || ""}`}>
          <span className="RestaurantInfo-label-description">
            {"telefono"}{" "}
          </span>
          {/* <meta itemProp="telephone" content={telephonePrimary} /> */}
          <a
            style={{ height: "31px", borderBottom: "none" }}
            className="foodiestrip_back_to_results"
            href={`tel:${telephonePrimary}`}
          >
            <span>{telephonePrimary}</span>
          </a>
        </div>
      );
    }
    if (restaurant.telephonePublic.length > 0) {
      phones = restaurant.telephonePublic.map((el, index) => {
        if (el.title && el.number) {
          return (
            <div key={`other-number-${index.toString()}`}>
              <span className="RestaurantInfo-label-description">
                {el.title || "telefono"}{" "}
              </span>
              {!restaurant.mainPhone && index === 0 ? null : (
                <meta itemProp="telephone" content={el.number} />
              )}
              <a
                style={{ height: "31px", borderBottom: "none" }}
                className="foodiestrip_back_to_results"
                href={`tel:${el.prefix || ""}${el.number}`}
              >
                {el.prefix ? <span>{el.prefix} </span> : null}
                <span>{el.number}</span>
              </a>
            </div>
          );
        }
        return null;
      });
    }
    return emails.concat(mainPhone).concat(phones);
  };

  let website = "";
  if (
    restaurant.links &&
    restaurant.links.webLinks &&
    restaurant.links.webLinks.length > 0 &&
    restaurant.links.webLinks[0]
  ) {
    if (!restaurant.links.webLinks[0].includes("http")) {
      website = `http://${restaurant.links.webLinks[0]}`;
    } else {
      website = restaurant.links.webLinks[0];
    }
  }
  let telephonePrimary =
    restaurant.telephonePublic.length > 0
      ? restaurant.telephonePublic[0].number
      : null;
  if (
    restaurant.mainPhone &&
    restaurant.mainPhone.prefix &&
    restaurant.mainPhone.number
  ) {
    telephonePrimary =
      restaurant.mainPhone.prefix + restaurant.mainPhone.number;
  }
  const restaurantPosition = `${restaurant.location.coordinates[1].toString()},${restaurant.location.coordinates[0].toString()}`;

  return (
    <>
      <h2 className="RestaurantInfo-category">
        {restaurant.categories[0] ? restaurant.categories[0][`label_it`] : ""}
        {props.isLogged ? (
          <SetFavorite
            isLogged={props.isLogged}
            restaurantId={restaurant._id}
          />
        ) : null}
      </h2>
      <div className="restaurant-head-name-certification-container">
        {restaurant.certificationRequest &&
        (restaurant.certificationRequest.status === "fulfilled" ||
          restaurant.certificationRequest.status === "completed") ? (
          <i className="icon icon-cockade-24 icon-certification-restaurant-details" />
        ) : null}
        <div
          className={
            restaurant.certificationRequest &&
            (restaurant.certificationRequest.status === "fulfilled" ||
              restaurant.certificationRequest.status === "completed")
              ? "resturant-head-name-with-certification"
              : "resturant-head-name-no-certification"
          }
        >
          <h2 className="RestaurantInfo-name" style={{ marginTop: "0" }}>
            {restaurant.name}
          </h2>
          {restaurant.nameInternational ? (
            <h4 className="RestaurantInfo-name-international">
              {restaurant.nameInternational}
            </h4>
          ) : null}
        </div>
      </div>
      {restaurant.certificationRequest ? getCertification() : null}
      <div>
        <h3 className="RestaurantInfo-address" style={{ marginTop: "0" }}>
          <span>
            {`${restaurant.address.route ? restaurant.address.route : ""} ${
              restaurant.address.streetNumber
                ? restaurant.address.streetNumber
                : ""
            }, ${
              restaurant.address.postalCode ? restaurant.address.postalCode : ""
            } ${
              restaurant[`addressIT`].admin3
                ? restaurant[`addressIT`].admin3.replace("Comune di", "")
                : ""
            } ${
              restaurant[`addressIT`].admin2
                ? restaurant[`addressIT`].admin2
                : ""
            } ${
              restaurant[`addressIT`].admin1
                ? restaurant[`addressIT`].admin1
                : ""
            } ${
              restaurant[`addressIT`].country
                ? restaurant[`addressIT`].country
                : ""
            }`}
          </span>
        </h3>
        {restaurant.address.addressDetails ? (
          <div className="RestaurantInfo-address" style={{ width: "100%" }}>
            <span
              className="RestaurantInfo-label-description"
              style={{ color: "#3c3c3b", marginRight: "0" }}
            >
              Nelle vicinanze
            </span>{" "}
            {`${restaurant.address.addressDetails}.`}
          </div>
        ) : null}
      </div>
      <div>
        {restaurant.categories && restaurant.categories.length > 1 ? (
          <div className="RestaurantInfo-crew">
            <span className="RestaurantInfo-label-description">
              Altre categorie
            </span>{" "}
            {getAttributes("categories")}
          </div>
        ) : null}
        {restaurant.idealForEventTypes &&
        restaurant.idealForEventTypes.length > 0 ? (
          <div className="RestaurantInfo-crew">
            <span className="RestaurantInfo-label-description">Ideale per</span>{" "}
            {getAttributes("idealFor")}
          </div>
        ) : null}
        {restaurant.typesOfFood && restaurant.typesOfFood.length > 0 ? (
          <div className="RestaurantInfo-crew">
            <span className="RestaurantInfo-label-description">
              Tipi di cucina{" "}
            </span>{" "}
            {getAttributes("foodTypes")}
          </div>
        ) : null}
        {restaurant.type &&
        restaurant.type === "hotel" &&
        restaurant.service &&
        restaurant.service.filter(el => el._id.type === "hotel").length > 0 ? (
          <div className="RestaurantInfo-crew">
            <span className="RestaurantInfo-label-description">
              Servizi hotel
            </span>{" "}
            {getAttributes("hotel")}
          </div>
        ) : null}
        {restaurant.service &&
        restaurant.service.length > 0 &&
        restaurant.service.some(el => el._id.type === "meal") ? (
          <div className="RestaurantInfo-crew">
            <span className="RestaurantInfo-label-description">Serviamo</span>{" "}
            {getAttributes("meal")}
          </div>
        ) : null}
        {restaurant.service &&
        restaurant.service.length > 0 &&
        restaurant.service.some(el => el._id.type === "parking") ? (
          <div className="RestaurantInfo-crew">{getParkingDetails()}</div>
        ) : null}
        {restaurant.publicTransport && restaurant.publicTransport.length > 0 ? (
          <p className="RestaurantInfo-crew">
            <span className="RestaurantInfo-label-description">
              Mezzi pubblici{" "}
            </span>{" "}
            {restaurant.publicTransport}
          </p>
        ) : null}
        {restaurant.links &&
        ((restaurant.links.facebookLinks &&
          restaurant.links.facebookLinks.length > 0 &&
          restaurant.links.facebookLinks[0]) ||
          (restaurant.links.googlePlusLinks &&
            restaurant.links.googlePlusLinks.length > 0 &&
            restaurant.links.googlePlusLinks[0]) ||
          (restaurant.links.instagramLinks &&
            restaurant.links.instagramLinks.length > 0 &&
            restaurant.links.instagramLinks[0]) ||
          (restaurant.links.linkedinLinks &&
            restaurant.links.linkedinLinks.length > 0 &&
            restaurant.links.linkedinLinks[0]) ||
          (restaurant.links.pinterestLinks &&
            restaurant.links.pinterestLinks.length > 0 &&
            restaurant.links.pinterestLinks[0]) ||
          (restaurant.links.twitterLinks &&
            restaurant.links.twitterLinks.length > 0 &&
            restaurant.links.twitterLinks[0])) ? (
          <div style={{ marginTop: "20px" }} className="RestaurantInfo-crew">
            <div className="resturant-head-social-container">
              <div
                style={{
                  float: "left",
                  marginRight: "10px",
                  lineHeight: "25px"
                }}
              >
                <span className="RestaurantInfo-label-description">
                  {"Social "}
                </span>
              </div>
              {getSocial()}
            </div>
          </div>
        ) : null}
        {website ? (
          <div
            className="RestaurantInfo-crew"
            style={{ float: "left", width: "100%" }}
          >
            <span className="RestaurantInfo-label-description">Web </span>
            <a
              style={{ textDecoration: "none" }}
              target="_blank"
              href={website}
              className="foodiestrip_back_to_results"
              itemProp="sameAs"
              rel="noopener noreferrer"
            >
              {website}
            </a>
          </div>
        ) : null}
        {restaurant.emailPublic &&
        restaurant.emailPublic.length > 0 &&
        restaurant.emailPublic[0].email ? (
          <div
            style={{
              fontSize: "15px",
              float: "left",
              width: "100%",
              marginBottom: "10px"
            }}
          >
            <span className="RestaurantInfo-label-description">E-mail </span>
            <a
              href={`mailto:${restaurant.emailPublic[0].email}`}
              className="foodiestrip_back_to_results"
              style={{
                textDecoration: "none",
                fontFamily: '"Archivo Narrow", sans-serif'
              }}
            >
              {restaurant.emailPublic[0].email}
            </a>
          </div>
        ) : null}
        {(restaurant.telephonePublic &&
          restaurant.telephonePublic.length > 0) ||
        (restaurant.emailPublic && restaurant.emailPublic.length > 1) ||
        (restaurant.mainPhone &&
          restaurant.mainPhone.prefix &&
          restaurant.mainPhone.number) ? (
          <div className="RestaurantInfo-crew" style={{ float: "left" }}>
            {/* <div className="RestaurantInfo-label-description">
                    {t('restaurantDetail.other_contacts')}
                  </div> */}
            {getContacts()}
          </div>
        ) : null}

        <div
          style={{
            marginTop: "10px",
            width: "100%",
            display: "inline-block",
            marginBottom: "20px"
          }}
        >
          {telephonePrimary ? (
            <div>
              <a
                className="call_now_button_container"
                href={`tel:${telephonePrimary}`}
              >
                <button
                  style={{ marginBottom: "20px" }}
                  className="show-more-results"
                >
                  Chiama Ora
                </button>
              </a>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href={`https://www.google.it/maps/@${restaurantPosition}`}
              >
                <button className="show-more-results">Come Arrivare</button>
              </a>
            </div>
          ) : null}
        </div>
      </div>
    </>
  );
}

RestaurantHead.propTypes = {
  restaurant: PropTypes.object.isRequired,
  isLogged: PropTypes.bool,
  isFavorite: PropTypes.bool
};

RestaurantHead.defaultProps = {
  isLogged: false
};
